import Buffer from './Buffer';

export default class IndexBuffer extends Buffer {

	constructor(gl, attributeName, itemSize, dynamic) {
		super(gl, gl.ELEMENT_ARRAY_BUFFER, attributeName, itemSize, dynamic, [Uint16Array]);
		throw new Error('Class incomplete');
	}

	bind() {
		this._gl.bindBuffer(this._type, this._object);
	}

	draw(primitiveType, itemCount = -1) {
		if (itemCount === -1) {
			itemCount = this.getItemCount();
		}
		const gl = this._gl;
		this.bind();
		gl.drawElements(primitiveType, itemCount, gl.UNSIGNED_SHORT, 0 /* offset */);
	}

}
